import React from 'react';
import { Page } from '../Page';
export function PageMealTiming() {
  return <Page pageNumber={22} variant="light" data-id="element-1491" data-mp="1dc2qolzui0dw">
      <div className="flex flex-col h-full" data-id="element-1492" data-mp="1dcubd1rwmdpe">
        {/* Accent image strip */}
        <div className="h-[160px] -mx-12 -mt-10 mb-8 overflow-hidden relative" data-id="element-1493" data-mp="zd337ho2jrjb">
          <img src="https://images.unsplash.com/photo-1495521821757-a1efb6729352?w=1000&q=80" alt="Meal preparation in kitchen" className="w-full h-full object-cover object-center" data-id="element-1494" data-mp="14b4hlpajv2og" />
          <div className="absolute inset-0 bg-gradient-to-t from-[#F5F5F0] via-transparent to-transparent" data-id="element-1495" data-mp="1wz0eov416wlr" />
        </div>

        <div className="mb-8" data-id="element-1496" data-mp="1iavsvi9om4yr">
          <p className="text-[10px] font-bold text-tealslate uppercase tracking-[0.2em] mb-3" data-id="element-1497" data-mp="1na8rf09x10h6">
            The Essentials
          </p>
          <h1 className="text-5xl font-serif text-[#1F1F1F] leading-tight mb-4" data-id="element-1498" data-mp="2ayrzbep1zb8q">
            When and How
            <br data-id="element-1499" data-mp="2frl0xtp863gl" />
            <span className="text-tealslate" data-id="element-1500" data-mp="2fs49ijszjfhy">Often to Eat</span>
          </h1>
          <div className="w-16 h-0.5 bg-tealslate" data-id="element-1501" data-mp="2sdxkouj40ywx" />
        </div>

        <p className="text-sm text-[#3B3B3B] leading-[1.8] mb-10 max-w-lg" data-id="element-1502" data-mp="2ne1i8zq29fjh">
          Because GLP-1 medications slow digestion, eating three large meals a
          day often leads to severe bloating, nausea, and acid reflux. You need
          to change how you structure your meals.
        </p>

        <div className="space-y-5 mb-10" data-id="element-1503" data-mp="3b33v7u9r2k7n">
          {[{
          num: '1',
          title: 'Eat Smaller, More Frequent Meals',
          text: 'Instead of 3 large meals, aim for 4-5 smaller meals or snacks throughout the day. This prevents your stomach from becoming overly full and reduces the risk of nausea.'
        }, {
          num: '2',
          title: 'Stop Eating Before You Feel Full',
          text: 'The fullness signal from your stomach to your brain is delayed. If you eat until you feel completely full, you will feel uncomfortably stuffed 20 minutes later. Stop at 80% full.'
        }, {
          num: '3',
          title: 'Close the Kitchen Early',
          text: 'Because food sits in your stomach longer, eating right before bed is a recipe for severe acid reflux. Stop eating at least 3 hours before you go to sleep.'
        }].map((item, i) => <div key={i} className="flex items-start gap-5" data-id="element-1504" data-mp="3ipom4ajny24" data-mpi={i}>
              <div className="w-8 h-8 rounded-full bg-tealslate flex items-center justify-center shrink-0 mt-0.5" data-id="element-1505" data-mp="7lw31z7t8vjo">
                <span className="text-sm font-serif text-white font-bold" data-id="element-1506" data-mp="cjxmil95ewvo">
                  {item.num}
                </span>
              </div>
              <div data-id="element-1507" data-mp="mc3azl06yw64">
                <h3 className="text-sm font-bold text-[#1F1F1F] mb-1" data-id="element-1508" data-mp="maif9s25576o">
                  {item.title}
                </h3>
                <p className="text-xs text-[#7A7A70] leading-[1.8]" data-id="element-1509" data-mp="rc7uzl0b6913">
                  {item.text}
                </p>
              </div>
            </div>)}
        </div>

        <div className="flex-1 flex items-end" data-id="element-1510" data-mp="2fvc2u972lhwq">
          <div className="border-l-4 border-tealslate pl-6 py-3" data-id="element-1511" data-mp="2fry02zuhv6or">
            <h3 className="font-bold text-[#1F1F1F] text-sm mb-1" data-id="element-1512" data-mp="2br4be4989nut">
              What About Calories?
            </h3>
            <p className="text-xs text-[#3B3B3B] leading-[1.8]" data-id="element-1513" data-mp="26voz3gqvc00i">
              You already have the calories and energy on your body, stored in
              the form of fat. If you find you can't exercise because you're too
              low on energy, adapt your calorie intake. Otherwise, stay focused
              on the big 5.
            </p>
          </div>
        </div>
      </div>
    </Page>;
}